import { css } from 'styled-components';
export const responsive = (type) => (strings, ...interpolations) => ({ theme }) => css `
    @media screen and (min-width: ${theme.breakpoints[type]}) {
      ${css(strings, ...interpolations)}
    }
  `;
//# sourceMappingURL=responsive.js.map